import './Errors.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { ReactElement } from 'react';
import { Auth } from '../../routes/config/Auth';

export const NotFoundView = (): ReactElement => {
  const { t } = useTranslator();
  return (
    <div className='not-found-page'>
      <div>
        <h1 className='error-header'>404</h1>
        <p className='error-body'>
          {t('404_body')} <br /> {t('404_body2')}
        </p>
        <a
          href={Auth.Login.Path}
          rel='noreferrer'
        >
          <Button startDecorator={<FontAwesomeIcon icon='home' />}>{t('projects_header')}</Button>
        </a>
      </div>
    </div>
  );
};
